import { Link, NavLink } from 'react-router-dom'
import './index.scss'
import LogoS from '../../assets/images/h.png'
import LogoSubtitle from '../../assets/images/hassan1.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faHome, faUser } from '@fortawesome/free-solid-svg-icons'
import {faDiscord, faLinkedin, faGithub, faInstagram} from '@fortawesome/free-brands-svg-icons'



const Sidebar = () => (
  <div className="nav-bar">
    <Link className="logo" to="/">
      <img src={LogoS} alt="logo" />  
      <img classname="sub-logo" src={LogoSubtitle} alt="slobodan" />
    </Link>
    <nav>
      <NavLink exact="true" activeclassname="active" to="/">
        <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
      </NavLink>
      <NavLink exact="true" activeclassname="active" className="about-link" to="/about">
        <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="contact-link"
        to="/contact"
      >
        <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
      </NavLink>
    </nav>
    <ul>
      <li>
       <a target="_blank"  rel="noreferer" href="https://www.linkedin.com/in/hassan-kazi-51a018184/">
       <FontAwesomeIcon  icon={faLinkedin} color="#4d4d4e" />
       </a>
      </li>
      <li>
       <a target="_blank" rel="noreferer" href="https://discord.com/channels/981946328277979166/981946328277979169">
       <FontAwesomeIcon  icon={faDiscord} color="#4d4d4e" />
       </a>
      </li>
      <li>
       <a target="_blank" rel="noreferer" href="https://www.instagram.com/hassan_kazi_48/">
       <FontAwesomeIcon  icon={faInstagram} color="#4d4d4e" />
       </a>
      </li>
      <li>
       <a target="_blank" rel="noreferer" href="https://github.com/ANDROIDHASSAN/">
       <FontAwesomeIcon  icon={faGithub} color="#4d4d4e" />
       </a>
      </li>
     
    
    
    </ul>
  </div>
)

export default Sidebar
